module.exports = __webpack_public_path__ + "media/images/membership2-3b25d076de9c4fab6db872f40660a1d4.jpeg";